import React, { useState } from 'react';

const BubbleText = () => {
  const [text, setText] = useState('');
  const [result, setResult] = useState('');
  const [size, setSize] = useState(20);
  const [circle, setCircle] = useState(true);

  // Unicode bubble characters mapping
  const bubbleCharMap = {
    'a': 'ⓐ', 'b': 'ⓑ', 'c': 'ⓒ', 'd': 'ⓓ', 'e': 'ⓔ',
    'f': 'ⓕ', 'g': 'ⓖ', 'h': 'ⓗ', 'i': 'ⓘ', 'j': 'ⓙ',
    'k': 'ⓚ', 'l': 'ⓛ', 'm': 'ⓜ', 'n': 'ⓝ', 'o': 'ⓞ',
    'p': 'ⓟ', 'q': 'ⓠ', 'r': 'ⓡ', 's': 'ⓢ', 't': 'ⓣ',
    'u': 'ⓤ', 'v': 'ⓥ', 'w': 'ⓦ', 'x': 'ⓧ', 'y': 'ⓨ', 
    'z': 'ⓩ',
    'A': 'Ⓐ', 'B': 'Ⓑ', 'C': 'Ⓒ', 'D': 'Ⓓ', 'E': 'Ⓔ',
    'F': 'Ⓕ', 'G': 'Ⓖ', 'H': 'Ⓗ', 'I': 'Ⓘ', 'J': 'Ⓙ',
    'K': 'Ⓚ', 'L': 'Ⓛ', 'M': 'Ⓜ', 'N': 'Ⓝ', 'O': 'Ⓞ',
    'P': 'Ⓟ', 'Q': 'Ⓠ', 'R': 'Ⓡ', 'S': 'Ⓢ', 'T': 'Ⓣ',
    'U': 'Ⓤ', 'V': 'Ⓥ', 'W': 'Ⓦ', 'X': 'Ⓧ', 'Y': 'Ⓨ', 
    'Z': 'Ⓩ'
  };

  const generateBubbleText = (inputText) => {
    const bubbleText = inputText
      .split('')
      .map(char => bubbleCharMap[char] || char)
      .join(' ');
    
    setResult(bubbleText);
    return bubbleText;
  };

  const handleTextChange = (e) => {
    const newText = e.target.value;
    setText(newText);
    generateBubbleText(newText);
  };

  const [copyButtonLabel, setCopyButtonLabel] = useState('Copy Text'); // State for button label


  const handleCopy = () => {
    const bubbleText = generateBubbleText(text);
    navigator.clipboard.writeText(bubbleText)
      setCopyButtonLabel('Copied!'); // Update button label to "Copied!"
      setTimeout(() => setCopyButtonLabel('Copy Text'), 1500); // Revert back to "Copy Number" after 1.5 seconds
  };

  const handleFontSizeChange = (e) => {
    setSize(e.target.value);
    generateBubbleText(text); // Update the bubble text with new size
  }


      // Clear input fields
      const clearFields = () => {
        setText('');
        setResult('');
        setSize('');
      };


     // Function to calculate text statistics
     const calculateTextStats = (text) => {
      const totalCharacters = text.length;
      const totalCharactersWithoutSpace = text.replace(/\s+/g, '').length;
      const totalWords = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
      const totalParagraphs = text.split(/\n+/).filter(Boolean).length;
      const totalSentences = text.split(/[.!?]+/).filter(Boolean).length;
  
      return {
        totalCharacters,
        totalCharactersWithoutSpace,
        totalWords,
        totalParagraphs,
        totalSentences,
      };
    };
  
  
      // Calculate stats dynamically based on current binary value
  const stats = calculateTextStats(text);

  return (
    <div className="container mt-5 p-4 bg-white rounded shadow">
      
      <textarea 
        className="form-control mb-4" 
        rows={5} 
        value={text} 
        onChange={handleTextChange} 
        placeholder="Enter your text here..." 
      />
      
      <div className="result border border-gray-400 p-4 rounded mb-4" style={{fontSize: size + 'px'}}>
        {result}
      </div>
      
      <label htmlFor="fontSize">Font Size:</label>
      <input type="number" id="fontSize" name="fontSize" value={size} onChange={handleFontSizeChange} /> 
      
   
      <button className="btn btn-primary" onClick={handleCopy}>
  {copyButtonLabel}
  </button>

      
      <button className="btn btn-danger" onClick={clearFields}>
            Clear
          </button>


      <div className="mt-3 text-muted">
            <p>
              Total Characters with Space: {stats.totalCharacters} | Total Characters without Space: {stats.totalCharactersWithoutSpace} | Total Words: {stats.totalWords}</p>
            <p>
               Total Paragraphs: {stats.totalParagraphs} | Total Sentences: {stats.totalSentences}
            </p>
          </div>
    </div>
  );
};

export default BubbleText;

